// FAQ Groups Navigation Component
const faqSections = document.querySelectorAll('[data-faq-section]')

faqSections.forEach((section) => {
    const navItems = section.querySelectorAll('.faq-groups__nav-item')
    const groups = section.querySelectorAll('.faq-groups__group')

    // Initialize FAQ group navigation
    if (navItems.length > 0) {
        navItems.forEach((navItem) => {
            navItem.addEventListener('click', function() {
                const groupSlug = this.getAttribute('data-faq-group-slug')
                
                if (groupSlug) {
                    setActiveGroup(groupSlug)
                }
            })
        })
    }

    // Set active FAQ group by slug
    function setActiveGroup(groupSlug) {
        // Update navigation
        navItems.forEach(item => {
            item.classList.remove('active')
        })
        const activeNavItem = section.querySelector(`[data-faq-group-slug="${groupSlug}"]`)
        if (activeNavItem) {
            activeNavItem.classList.add('active')
        }

        // Update content groups
        groups.forEach(group => {
            group.classList.remove('active')
        })
        const activeGroup = section.querySelector(`[data-faq-group-content-slug="${groupSlug}"]`)
        if (activeGroup) {
            activeGroup.classList.add('active')
        }
    }

    // Generate slug from title
    function createSlug(title) {
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '') // Remove special characters
            .replace(/[\s_-]+/g, '-') // Replace spaces/underscores with single dash
            .replace(/^-+|-+$/g, '') // Remove leading/trailing dashes
    }

    // Make createSlug available globally for template use
    window.createFaqSlug = createSlug
}) 